module.exports = __webpack_public_path__ + "fonts/Roboto-LightItalic-9175faa6.woff";